import type { Component } from "svelte";
import { get, writable } from "svelte/store";

interface IPopperOptions {
	closeOnContentClick: boolean;
}

let component = writable<(Component | null) | null>(null);
let target = writable<HTMLElement | null>(null);
let options = writable<IPopperOptions>({ closeOnContentClick: false });

export function usePopper() {
	function open(
		component_: Component,
		target_: HTMLElement | null,
		options_?: IPopperOptions
	) {
		if (component_ !== get(component)) {
			component.set(component_);
			if (options_) {
				options.set(options_);
			}
		} else {
			close();
		}
		target.set(target_);
	}

	function close() {
		component.set(null);
		target.set(null);
		options.set({ closeOnContentClick: false });
	}

	return { open, close, component, target, options };
}
